import styled from 'styled-components'

export const Button = styled('button')`
  padding: 0px;
  margin: 0px;
  border: 0px;
  width: 22px;
  height: 22px;
  border: 1px solid #e5e5e5;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border-radius: 100%;
  flex-shrink: 0;
  cursor: pointer;
`